.dialog {
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
}

.subtitle {
  margin-bottom: 16px;
}
